import {
  FactureProducts,
  findFiltreSoldProductsApi,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";

import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";

const ModalFacture = ({ filtre, showModal, setShowModal }: any) => {
  const dispatch = useAppDispatch();
  const products = useAppSelector(FactureProducts);

  useEffect(() => {
    const fetchData = async () => {
      if (filtre && showModal) {
        console.log("Fetching with filtre:", filtre);
        dispatch(findFiltreSoldProductsApi(filtre));
      }
    };

    fetchData();
  }, [filtre, showModal, dispatch]);

  let date = new Date();
  const [isPrinting, setIsPrinting] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);
  const [checkedItems, setCheckedItems] = useState<any[]>([]);

  const handleCheckboxChange = (itemId: number) => {
    const isChecked = checkedItems.includes(itemId);

    if (isChecked) {
      setCheckedItems(checkedItems.filter((id) => id !== itemId));
    } else {
      setCheckedItems([...checkedItems, itemId]);
    }
  };

  return (
    <>
      {" "}
      {products ? (
        <Modal size="xl" show={showModal} onHide={() => setShowModal(false)}>
          {" "}
          <div className="row invoice layout-spacing">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="doc-container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="invoice-container">
                      <div className="invoice-inbox" ref={componentRef}>
                        <div id="ct" className="">
                          <div className="invoice-00001">
                            <div className="content-section">
                              <div className="inv--head-section inv--detail-section">
                                <div className="row">
                                  <div className="col-sm-6 col-12 mr-auto">
                                    <div className="d-flex">
                                      <h6 className="in-heading align-self-center mb-0">
                                        {products.societeName}
                                      </h6>
                                    </div>
                                    <div className="d-flex">
                                      <h6 className="in-heading align-self-center mb-0">
                                        {products.organisationName}
                                      </h6>
                                    </div>
                                    {products?.vendeursNames?.length ? (
                                      <div className="d-flex">
                                        <h6 className="in-heading align-self-center mb-0">
                                          {"Vendeurs : " +
                                            products.vendeursNames.map(
                                              (vendeur: string) => vendeur + " "
                                            )}
                                        </h6>
                                      </div>
                                    ) : null}
                                    {products.caissiersNames?.length ? (
                                      <div className="d-flex">
                                        <h6 className="in-heading align-self-center mb-0">
                                          {"Caissiers : " +
                                            products.caissiersNames.map(
                                              (vendeur: string) => vendeur + " "
                                            )}
                                        </h6>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="col-sm-6 col-12 mr-auto">
                                    <div className="d-flex">
                                      <h6 className="in-heading align-self-center mb-0">
                                        {filtre.dateDebut === filtre.dateFin
                                          ? "Ventes de " + filtre.dateDebut
                                          : "Ventes de " +
                                            filtre.dateDebut +
                                            " a " +
                                            filtre.dateFin}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="inv--product-table-section">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead className="">
                                      <tr>
                                        <th scope="col" style={{ width: "5%" }}>
                                          N°
                                        </th>
                                        <th
                                          scope="col"
                                          style={{ width: "10%" }}
                                        >
                                          Ref
                                        </th>
                                        <th
                                          className="text-right"
                                          scope="col"
                                          style={{ width: "20%" }}
                                        >
                                          Article
                                        </th>
                                        <th
                                          className="text-right"
                                          scope="col"
                                          style={{ width: "10%" }}
                                        >
                                          Prix HT
                                        </th>
                                        <th
                                          className="text-right"
                                          scope="col"
                                          style={{ width: "5%" }}
                                        >
                                          Qte
                                        </th>

                                        <th
                                          className="text-right"
                                          scope="col"
                                          style={{ width: "10%" }}
                                        >
                                          Total TTC
                                        </th>
                                        <th
                                          className="text-right"
                                          scope="col"
                                          style={{ width: "10%" }}
                                        >
                                          Total Net HT
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                        !isPrinting
                                          ? products &&
                                            products.data &&
                                            Object.values(products.data).map(
                                              (item: any, index: number) => {
                                                const codeArticle =
                                                  item?.product?.code_article;

                                                return (
                                                  <tr key={index}>
                                                    <td> {index + 1} </td>
                                                    <td>{codeArticle}</td>
                                                    <td className="text-right">
                                                      {item?.product?.titre?.fr}
                                                    </td>
                                                    <td className="text-right">
                                                      {item?.product?.prix_vente_ht?.toFixed(
                                                        3
                                                      )}
                                                    </td>
                                                    <td className="text-right">
                                                      {item?.quantity}
                                                    </td>

                                                    <td className="text-right">
                                                      {(
                                                        item.product
                                                          ?.prix_vente_ht *
                                                        item?.quantity
                                                      ).toFixed(3)}
                                                    </td>
                                                    <td className="text-right">
                                                      {" "}
                                                      {(
                                                        item.product
                                                          ?.prix_vente_ttc *
                                                        item?.quantity
                                                      ).toFixed(3)}
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )
                                          : null
                                        // eliminateItemsFromArray1() &&
                                        //   eliminateItemsFromArray1().map(
                                        //     (item: any, index: number) => {
                                        //       const calculatedRemise =
                                        //         (item.product.prix_vente_ht *
                                        //           item.quantity *
                                        //           item.product.remise) /
                                        //         100;

                                        //       const codeArticle =
                                        //         item.product.code_article;

                                        //       return (
                                        //         <tr key={index}>
                                        //           <td> {index + 1} </td>
                                        //           <td>{codeArticle}</td>
                                        //           <td className="text-right">
                                        //             {!isPrinting ? (
                                        //               <input
                                        //                 type="checkbox"
                                        //                 onChange={() =>
                                        //                   handleCheckboxChange(
                                        //                     item.product._id
                                        //                   )
                                        //                 }
                                        //                 checked={checkedItems.includes(
                                        //                   item.product._id
                                        //                 )}
                                        //               />
                                        //             ) : null}{" "}
                                        //             {item.product.titre.fr}
                                        //           </td>
                                        //           <td className="text-right">
                                        //             {item.product.prix_vente_ht.toFixed(
                                        //               3
                                        //             )}
                                        //           </td>
                                        //           <td className="text-right">
                                        //             {item.quantity}
                                        //           </td>

                                        //           <td className="text-right">
                                        //             {item.product.tva}
                                        //           </td>
                                        //           <td className="text-right">
                                        //             {item.product.remise}
                                        //           </td>
                                        //           <td className="text-right">
                                        //             {(
                                        //               item.product
                                        //                 .prix_vente_ht *
                                        //               item.quantity
                                        //             ).toFixed(3)}
                                        //           </td>
                                        //           <td className="text-right">
                                        //             {/* Prix HT = Prix TTC ÷ (1 + Taux de TVA) */}{" "}
                                        //             {(
                                        //               item.product
                                        //                 .prix_vente_ht *
                                        //                 item.quantity -
                                        //               calculatedRemise
                                        //             ).toFixed(3)}{" "}
                                        //           </td>
                                        //         </tr>
                                        //       );
                                        //     }
                                        //   )
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              <div className="inv--total-amounts">
                                <div className="row mt-4">
                                  <div className="col-sm-5 col-12 order-sm-0 order-1"></div>
                                  <div className="col-sm-7 col-12 order-sm-1 order-0">
                                    <div className="text-sm-right">
                                      <div className="row">
                                        <div className="col-sm-8 col-7">
                                          <p className="">Total HT : </p>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                          <p className="">
                                            {" "}
                                            {products.totalHT?.toFixed(3)}{" "}
                                          </p>
                                        </div>

                                        <div className="col-sm-8 col-7">
                                          <p className="">Total TTC </p>
                                        </div>
                                        <div className="col-sm-4 col-5">
                                          <p className="">
                                            {products.totalTTC?.toFixed(3)}{" "}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <table
                                  border={1}
                                  cellPadding="10"
                                  style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th>Méthode</th>
                                      <th>Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {products.payments &&
                                      Object.entries(products?.payments).map(
                                        ([method, amount]: any) => (
                                          <tr
                                            key={
                                              method === "Cash"
                                                ? "Espéces"
                                                : method
                                            }
                                          >
                                            <td>{method}</td>
                                            <td>{amount.toFixed(3)} TND</td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary" style={{ width: "100%" }}>
                Print
              </button>
            )}
            content={() => componentRef.current}
          />
        </Modal>
      ) : null}
    </>
  );
};
export default ModalFacture;
